import { Alert } from "@p0security/ui";

export const OwnerAlert = () => (
  <Alert
    message="Only P0 owners may install integrations"
    icon
    type="warning"
  />
);
